export default __webpack_public_path__ + "static/026-728d968881f22bb32a69be208d0e1e6d.png";